import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';

export default function CommunitySearch({ onSearch, placeholderText }) {
    const [search, setSearch] = useState('');

    useEffect(() => {
        const delay = search === '' ? 0 : 400;

        const timer = setTimeout(() => {
            if (typeof onSearch === 'function') {
                onSearch(search);
            }
        }, delay);

        return () => clearTimeout(timer);
    }, [search, onSearch]);

    return (
        <Form className="mb-4" onSubmit={(e) => e.preventDefault()}>
            <Form.Control
                type="text"
                aria-label="Search communities"
                placeholder={placeholderText}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            />
        </Form>
    );
}

CommunitySearch.propTypes = {
    onSearch: PropTypes.func.isRequired,
    placeholderText: PropTypes.string.isRequired,
};
